import React, { FC, ReactNode, useRef } from "react";
import styles from "./file-upload-button.module.scss";
import Button from "../../../components/ui-kit/button/button";

interface FileUploadButtonProps {
  accept: string;
  multiple: boolean;
  disabled: boolean;
  onChange: (validFiles: File[]) => void;
  buttonLabel: ReactNode;
  buttonClassName?: string;
}

const FileUploadButton: FC<FileUploadButtonProps> = ({
  accept,
  multiple,
  disabled,
  onChange,
  buttonLabel,
  buttonClassName,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleUploadButtonClick = () => {
    inputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const acceptedTypes = accept.split(",").map((t) => t.trim().toLowerCase());

    const validFiles = Array.from(files).filter((file) =>
      acceptedTypes.includes(file.type.toLowerCase()),
    );

    const invalidFiles = Array.from(files).filter(
      (file) => !acceptedTypes.includes(file.type.toLowerCase()),
    );

    if (invalidFiles.length > 0) {
      alert(
        `Some files were not uploaded due to unsupported format: ${invalidFiles.map((f) => f.name).join(", ")}`,
      );
    }

    if (validFiles.length > 0) {
      onChange(validFiles);
    }

    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return (
    <div className={styles.uploadWrapper}>
      <input
        type="file"
        accept={accept}
        onChange={handleFileChange}
        multiple={multiple}
        className={styles.hiddenInput}
        ref={inputRef}
      />
      <Button
        className={buttonClassName}
        type="outline"
        disabled={disabled}
        onClick={handleUploadButtonClick}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};

export default FileUploadButton;
